





































// Utils
import { Component, Vue } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import moment from 'moment'
// Components
import UserInfo from '@/components/user/companyDetail/UserInfo.vue'
import CompanyInfo from '@/components/user/companyDetail/CompanyInfo.vue'
import PartnerInfo from '@/components/user/companyDetail/PartnerInfo.vue'
import BillingInfo from '@/components/user/companyDetail/BillingInfo.vue'
import ShippingInfo from '@/components/user/companyDetail/ShippingInfo.vue'
import Denominations from '@/components/user/companyDetail/Denominations.vue'
import CommissaryInfo from '@/components/user/companyDetail/CommissaryInfo.vue'
import CompanyCouncil from '@/components/user/companyDetail/CompanyCouncil.vue'
import ShareDistribution from '@/components/user/companyDetail/ShareDistribution.vue'
import ModalStatusExpedient from '@/components/user/companyDetail/ModalStatusExpedient.vue'
import ModalApprovedOrRejectDocument from '@/components/user/ModalApprovedOrRejectDocument.vue'
// Types
import CompanyTypes from '@/store/types/CompanyTypes'
// Services
import Company from '@/services/Company'

moment.locale('es')
@Component({
  components: { UserInfo, CompanyInfo, PartnerInfo, BillingInfo, ShippingInfo, Denominations, CommissaryInfo, CompanyCouncil, ShareDistribution, ModalStatusExpedient, ModalApprovedOrRejectDocument }
})
export default class CompanyInformation extends Vue {
  status = { showModal: false }

  get validateStageComplete () {
    return this.company.stages.findIndex((stage: any) => stage.stage_name === 'documents_approved' && stage.is_completed) === -1
  }

  get validateExpedientCompleted () {
    if (this.company.expedient_completed === false) {
      return false
    } return true
    // return this.company.expedient_completed
  }

  getNameForRoleInCouncil (role: string) {
    return this.company.council.filter((council: any) => council.council_role === role)
  }

  searchDocumentWithErrors () {
    let complete = true
    const commissary = this.getNameForRoleInCouncil('commissary')
    this.company.partners.map((partner: any) => {
      const complementaries = partner.civil_status === 'soltero'
        ? partner.cfi.document_url === null
          ? false
          : partner.cfi.is_approved && partner.cfi.rejection_category === null
        : (partner.cfi.document_url === null ||
          partner.id_spouse.document_url === null ||
          partner.marriage_certificate.document_url === null
          ? false
          : partner.cfi.is_approved && partner.cfi.rejection_category === null &&
            partner.id_spouse.is_approved && partner.id_spouse.rejection_category === null &&
            partner.marriage_certificate.is_approved && partner.marriage_certificate.rejection_category === null)
      if (!complementaries || partner.rfc === '' || partner.mati_verification_status !== 'VERIFIED') complete = false
    })
    if (commissary.length && commissary[0].other_faculty !== 'Partner') {
      if (!this.company.commissary_council.documents.length) complete = false
    }
    return complete
    // return this.company.partners.filter((partner: any) => partner.documents.find((document: any) => !document.is_approved)).length > 0
  }

  async approvedDocument () {
    this.loading(true)
    const [error] = await Company.updateStageByCompanyId(this.company.id, 'documents_approved')
    if (error) {
      this.loading(false)
      return this.$toasted.global.error(error)
    }
    const [error2] = await Company.updateStageByCompanyId(this.company.id, 'partners_data')
    if (error2) {
      this.loading(false)
      return this.$toasted.global.error(error2)
    }
    const [err] = await this.setCompanyData(this.company.id)
    if (err) return this.$toasted.global.error(err)
    await this.saveRender()
    this.$toasted.global.success({ message: 'Se aprobo el expediente con éxito' })
  }

  async saveRender () {
    this.loading(true)
    /* const [error] = await Company.getRenderConstitutive(this.company.id, true)
    if (error) {
      this.loading(false)
      return this.$toasted.global.error(error)
    } */
    const [error2] = await Company.endEdit(this.company.id)
    if (error2) {
      this.loading(false)
      return this.$toasted.global.error(error2)
    }
    const [err] = await this.setCompanyData(this.company.id)
    this.loading(false)
    if (err) return this.$toasted.global.error(err)
    this.$toasted.global.success({ message: 'Se genero el acta renderizada con éxito' })
  }

  @Getter(`CompanyModule/${CompanyTypes.getters.GET_DATA}`) company: any
  @Action('UPDATE_STATE_LOADING') loading: any
  @Action(`CompanyModule/${CompanyTypes.actions.UPDATE_DATA}`) setCompanyData: any
}
